/*
 * Crea y destruye el link temporal de descarga
 * @param {*} event Contenido de la descarga en objeto Blob
 * @param {*} nameFile Nombre del archivo con extención
 */
const linkDescarga = (event, nameFile) => {
    var link = document.createElement('a');
    link.href = event.target.result;
    link.target = '_blank';
    link.download = nameFile;
    link.click();
    (window.URL || window.webkitURL).revokeObjectURL(link.href);
}

/**
 * Prepara la lectura y descarga del contenido
 * @param {*} content Contenido de la descarga en objeto Blob
 * @param {*} nameFile Nombre del archivo
 */
const downloadCsv = (content, nameFile) => {
    var reader = new FileReader();
    reader.onload = (event) => {
        linkDescarga(event, `${nameFile}.csv`);
    };
    reader.readAsDataURL(content);
}

export default downloadCsv;